import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { QualityControlHdrContainerModel } from "../../../../../../../models/aggregates/alg/cc/quality-control/quality-control-hdr-container.model";
import { BaseApiTemplateService } from "../../../shared/base-api-template-service.model";
import { Core2Config } from "../../../shared/core2Config";

@Injectable({
	providedIn: "root",
})
export class QualityControlHdrService extends BaseApiTemplateService<QualityControlHdrContainerModel> {
	readonly url =
		Core2Config.TENANT_DOMAIN_URL_PREFIX +
		Core2Config.ALG_CC_MODULE +
		"qc/hdrs";

	constructor(http: HttpClient) {
		super();
		this.apiUrl =
			Core2Config.DOMAIN_URL +
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.ALG_CC_MODULE +
			"qc/hdrs";
		this.endpoint_path =
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.ALG_CC_MODULE +
			"qc/hdrs";
		this.httpClient = http;
	}
}
